import { Chip } from '@material-ui/core';

// Helper function to get lifecycle chip color
const getLifecycleColor = (
  lifecycle: string,
): 'default' | 'primary' | 'secondary' => {
  switch (lifecycle.toLowerCase()) {
    case 'production':
      return 'primary';
    case 'non-production':
      return 'secondary';
    case 'deprecated':
    case 'sunset':
      return 'default';
    default:
      return 'default';
  }
};

export interface LifecycleChipProps {
  lifecycle?: string | undefined;
}

export const LifecycleChip: React.FC<LifecycleChipProps> = ({ lifecycle }) => {
  if (!lifecycle) {
    return (
      <Chip
        size="small"
        label="Not specified"
        color="default"
        variant="outlined"
      />
    );
  }

  return (
    <Chip
      size="small"
      label={String(lifecycle)}
      color={getLifecycleColor(String(lifecycle))}
    />
  );
};
